import { render, staticRenderFns } from "./CorrelationGroupList.vue?vue&type=template&id=64b802eb&scoped=true&"
import script from "./CorrelationGroupList.vue?vue&type=script&lang=ts&"
export * from "./CorrelationGroupList.vue?vue&type=script&lang=ts&"
import style0 from "./CorrelationGroupList.vue?vue&type=style&index=0&id=64b802eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b802eb",
  null
  
)

export default component.exports